<template>
  <div>
    <!-- 分销商设置 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>分销商设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="contentBox">
      <div class="contentOne">
        <div>
          <div>基本信息</div>
          <el-divider></el-divider>
          <el-descriptions :column="1" direction="vertical">
            <el-descriptions-item label="简称">{{form.Name}}</el-descriptions-item>
            <el-descriptions-item label="全称">{{form.FullName}}</el-descriptions-item>
            <el-descriptions-item label="联系人">{{form.LinkMan}}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{form.Phone}}</el-descriptions-item>
            <el-descriptions-item label="Email">{{form.E_Mail}}</el-descriptions-item>
            <el-descriptions-item label="分销商详细地址">{{form.Address}}</el-descriptions-item>
            <!-- <el-descriptions-item label="经纬度">
              <div>经度:121</div>
              <div>纬度:121</div>
            </el-descriptions-item> -->
          </el-descriptions>
        </div>
        <div>
          <div>基础设置</div>
          <el-divider></el-divider>
          <div>
            <span>注:</span>
            <span>频次限制默认3次/天,计时默认结束三天前提醒,设置不得大于6</span>
          </div>
          <div class="basicsForm">
            <el-form ref="form" :model="form" label-width="120px">
              <div class="itemOne">
                <el-form-item label="首次提醒额度:">
                  <el-input v-model="form.first_quota"></el-input>
                  <span class="dw">元</span>
                </el-form-item>
                <el-form-item label="最低提醒额度:">
                  <el-input v-model="form.end_quota"></el-input>
                  <span class="dw">元</span>
                </el-form-item>
              </div>
              <div class="itemTwo">
                <el-form-item label="频次限制:">
                  <el-input v-model="form.limit"></el-input>
                  <span class="dw">次/天</span>
                </el-form-item>
              </div>
              <!-- <el-form-item label="是否发送短信:">
                <el-radio-group v-model="form.sms_flag">
                  <el-radio label="1">发送</el-radio>
                  <el-radio label="2">不发送</el-radio>
                </el-radio-group>
              </el-form-item> -->
              <el-form-item class="itemBtn">
                <el-button class="btnL" @click="preserve">确认保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="contentTwo">
        <div>基础设置</div>
        <el-divider></el-divider>
        <div class="TwoForm">
          <el-form v-model="form" :rules="rule">
            <el-form-item >
              <span class="formnames">接口地址:</span>
              <el-input style="margin-top:1rem;" disabled value="新：http://xwt.softykt.net/api/orderapi"></el-input>
            </el-form-item>
            
            <el-form-item >
              <span class="formnames">APPID:</span>
              <el-input disabled v-model="form.UserCode" placeholder="APPID"></el-input>
            </el-form-item>
            <el-form-item >
              <span class="formnames">softyktsecrect:</span>
              <el-input v-model="form.Diskey" disabled placeholder="--" :type='show?"text":"password"'></el-input>
            </el-form-item>
            <el-form-item class="itemBtn">
              <el-button @click="changePass">{{ show?'隐藏':'查看' }}</el-button>
              <el-button @click="suiji">生成秘钥</el-button>
            </el-form-item>
          
            <el-form-item label="回调Url:"  prop="url">
              <el-input v-model="form.AgainUrl" placeholder="--"></el-input>
            </el-form-item>
            <el-form-item class="itemBtn copyClick">
              <el-button  @click="yanzheng">保存配置信息</el-button>
            </el-form-item>
            <span class="txt_span" @click="copys">复制配置信息</span>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDistributorDetail,
  setDistributorQuotaRemind,
  setDistributorApiAccount
} from '@/request/distributor.js'
export default {
  data() {
    return {
      radio: "",
      form: {
        AgainUrl:''
      },
      rule:{
        url: [
          {type: 'url', message: `请输入正确的url`, trigger: 'change'}
        ]
      },
      show:false,
      Diskey:'',
      AgainUrl:''
    };
  },
  created(){
    this.getList()
  },
  methods:{
    copys(){
        let oInput = document.createElement('input');
        oInput.value =`新版接口地址：http://xwt.softykt.net/api/orderapi ; APPID: ${this.form.UserCode} ; softyktsecrect：${this.form.Diskey} ; 回调URL：${this.form.AgainUrl}`;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        console.log(oInput.value)
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message.success('复制成功')
    },
    changePass(){
      this.show = !this.show
    },
    getList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      getDistributorDetail(data).then(res=>{
        if(res.data.status=='ok'){
          this.form = res.data.result
          this.form.sms_flag  = this.form.sms_flag + ''
          this.Diskey = res.data.result.Diskey
          this.AgainUrl = res.data.result.AgainUrl
        }
      })
    },
    // 基础设置保存
    preserve(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        first_quota:this.form.first_quota,
        end_quota:this.form.end_quota,
        limit:this.form.limit,
        sms:this.form.sms_flag
      }
      setDistributorQuotaRemind(data).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('保存成功')
          this.getList()
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    // 随机获取 验证
    suiji(){
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var maxPos = chars.length;
      let num = ''
      for (let i = 0; i < 32; i++) {
         num += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      this.form.Diskey = num
      let data = {
        token:window.sessionStorage.getItem('Token'),
        softyktsecrect:this.form.Diskey,
        notify_url:this.form.AgainUrl
      }
      setDistributorApiAccount(data).then(res=>{
          if(res.data.status =='ok'){
            this.$message.success('成功')
          }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    yanzheng(){
      if(this.Diskey==this.form.Diskey&&this.AgainUrl==this.form.AgainUrl){
        this.$message.error('数据未发生变化，禁止验证')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        softyktsecrect:this.form.Diskey,
        notify_url:this.form.AgainUrl
      }
      setDistributorApiAccount(data).then(res=>{
          if(res.data.status =='ok'){
            this.$message.success('成功')
            let oInput = document.createElement('input');
            oInput.value =`接口地址：http://api.softykt.net/Api1_0 ; APPID: ${this.form.UserCode} ; softyktsecrect：${this.form.Diskey} ; 回调URL：${this.form.AgainUrl}`;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            console.log(oInput.value)
            document.execCommand("Copy"); // 执行浏览器复制命令
          }else{
              this.$message.error(res.data.msg);
          }
      })
    }
  }
};
</script>

<style lang='less' scoped>
.basicsForm {
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    // font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .dw {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
    margin-left: 10px;
  }

  .itemOne {
    /deep/ .el-form-item__content{
      display: flex;
    }
    .el-input {
      // width: 300px;
    }
  }
  .itemTwo {
    .el-input {
      // width: 280px;
    }
  }
}
.contentBox {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .contentOne {
    width: 66.5%;
    min-width: 400px;
    height: 810px;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    justify-content: space-between;
    > div:nth-child(1) {
      width: 100%;
      height: 420px;
      padding: 20px;
      background: #ffffff;
      border-radius: 4px;
      box-sizing: border-box;
      > div:nth-child(1) {
        height: 40px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        color: #000000;
      }
    }
    > div:nth-child(2) {
      width: 100%;
      // height: 370px;
      margin: 20px 0 0 0;
      box-sizing: border-box;
      padding: 20px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 4px;
      /deep/.el-form-item {
        margin-bottom: 12px;
      }
      .itemBtn {
        display: flex;
        justify-content: center;
        margin-left: -100px;
        .el-button {
          border: none;
          background: #d9d9d9;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          text-align: center;
          color: #ffffff;
        }
        .btnL {
          width: 100px;
          border: none;
          background: #246deb;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          text-align: center;
          color: #ffffff;
          margin-left: 20px;
        }
      }
      > div:nth-child(1) {
        height: 40px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        color: #000000;
      }
      > div:nth-child(3) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #e74c3c;
        margin-bottom: 1rem;
      }
    }
  }
  .contentTwo {
    min-width: 300px;
    width: 32.5%;
    height: 810px;
    padding: 20px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px;
    > div:nth-child(1) {
      height: 40px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      color: #000000;
    }
    .TwoForm {
      /deep/.el-form-item__label {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      /deep/.el-form-item {
        margin-bottom: 1rem;
        position: relative;
      }
      .xingA {
        position: absolute;
        top: 0px;
        left: -5px;
        color: #e74c3c;
      }
      .itemBtn {
        display: flex;
        justify-content: flex-end;
        .el-button {
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          text-align: center;
          color: #246deb;
        }
      }
    }
  }
}
// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 10px 0;
}
// 描述列表
/deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 0px;
}
/deep/.el-descriptions-item__label {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
/deep/.el-descriptions-item__content {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 13px;
}
.basicsForm{
  /deep/.el-input{
    width: 30rem;
  }
}
.formnames{
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
.copyClick{
  justify-content: center !important;
  margin-top: 4rem;
}
.txt_span{
  display: flex;
  justify-content: center;
  font-size: 1.4rem;
  color: red;
  cursor: pointer;
}
</style>